<div class="modal-body wrapper-modal position-relative w-100 d-flex flex-column">
    <i matTooltip="Cerrar" class="fas fa-times fa-2xl close-icon-actions" (click)="dialogRef.close()"></i>
    <section class="px-2 px-md-5" *ngIf="cargosWithoutErrors?.length">
        <h2 class="text-bold text-center my-4 text-balance">{{title}}</h2>
        <div class="cargo-created-card" *ngFor="let cargo of cargosWithoutErrors">
            <h5 class="text-bold mb-0">ID.{{cargo?.cargo?.consecutive}}</h5>
            <button mat-raised-button class="primary-secondary button-width-auto" type="button" color="primary"
                (click)="goToCargo(cargo?.cargo)">
                <span>Seguir diligenciando</span>
            </button>
        </div>
    </section>
    <section class="pax-2 px-md-5" *ngIf="cargosWithErrors?.length">
        <h2 class="text-bold text-center my-4 text-balance">Ocurrió un error con
            {{cargosWithErrors.length === 1
            ? 'el siguiente servicio'
            : 'los siguientes servicios'}}
        </h2>
        <div class="cargo-created-card" *ngFor="let cargo of cargosWithErrors">
            <h5 class="text-bold mb-0">ID.{{cargo?.cargo?.consecutive}} {{cargo?.error ? ": " + cargo?.error : ''}}</h5>
        </div>
    </section>
    <div class="button-container mt-4">
        <button mat-raised-button color="accent" type="button" (click)="goToListCargos()" *ngIf="hasCommonCargoList">
            <span class="text-bold">Ir a {{hasCommonCargoList.state}}</span>
        </button>
    </div>
</div>